import { render, staticRenderFns } from "./mainHuikuManage.vue?vue&type=template&id=778b5df8&scoped=true&"
import script from "./mainHuikuManage.vue?vue&type=script&lang=js&"
export * from "./mainHuikuManage.vue?vue&type=script&lang=js&"
import style0 from "./mainHuikuManage.vue?vue&type=style&index=0&id=778b5df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b5df8",
  null
  
)

export default component.exports